import React, {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import MetricBar from "./MetricBar";
import api from "../utils/api";
import {DeviceMetric, getBodyStandardRanges, MetricRange} from "../utils/deviceInfo";

// 측정 항목 목록
// 체성분 항목은 회원의 키 / 성별에 따라 표준 범위가 달라지므로 프로필을 조회해서 판정함
const MetricBarList = (props: { metrics: DeviceMetric[], values: { [key: string]: number } }) => {
  const [standardRanges, setStandardRanges] = useState<{ [key: string]: MetricRange }>({});
  const hasBodyMetric = props.metrics.filter((metric) => metric.group === 'body').length > 0;

  useEffect(() => {
    if (!hasBodyMetric) {
      return;
    }
    api.get('permission/getProfile').then((res: any) => {
      setStandardRanges(getBodyStandardRanges(res.data.height, res.data.sex));
    }).catch(function (error: any) {
      console.log(error)
    });
  }, [hasBodyMetric]);

  return (
    <Box>
      {props.metrics.map((metric, index) => (
        <Box key={metric.key}>
          {index > 0 ? <Divider /> : null}
          <MetricBar metric={metric} value={props.values[metric.key]} normalRange={standardRanges[metric.key]} />
        </Box>
      ))}
    </Box>
  );
}

export default MetricBarList;
